import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SignaturePad from 'react-signature-pad-wrapper';
import ReplayIcon from '@mui/icons-material/Replay';
import ClearIcon from '@mui/icons-material/Clear';
import Footer from './Common_Components/Footer';

const Writting = () => {
    const location = useLocation();
    const [activePage, setActivePage] = useState("Learning");
    const navigate = useNavigate();
    const day = location.state?.day || "Day Module";
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");


    const signaturePadRef = useRef(null);

    const handleClear = () => {
        if (signaturePadRef.current) {
            signaturePadRef.current.clear();
        }
    };

    const handleUndo = () => {
        const data = signaturePadRef.current.toData();
        if (data) {
            data.pop(); // Remove the last stroke
            signaturePadRef.current.fromData(data);
        }
    };

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate()} className='icon_1' />
                            <h2>Writing Practice</h2> {/* Display the selected day */}
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="tiles-wrapper">
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>

                            <div className="drawing-practice">
                                <h2 className="drawing-practice-header">Drawing Practice</h2>
                                <div className="plus-horizontal"></div>
                                <div className="plus-vertical"></div>
                                <SignaturePad
                                    ref={signaturePadRef}
                                    options={{
                                        minWidth: 1,
                                        maxWidth: 3,
                                        penColor: "black"
                                    }}
                                    canvasProps={{ width: 350, height: 350, className: 'signature-canvas' }}
                                />
                            </div>

                            <div className="controls">
                                <div className="clear-cls">
                                    <ClearIcon onClick={handleClear} />
                                </div>
                                <div className="undo-cls">
                                    <ReplayIcon onClick={handleUndo} />
                                </div>
                            </div>

                            <h2 className="character-learning-header">Character Learning</h2>
                            <h2 className="practice-writing-header">Practice writing</h2>

                            <div className="character-learning">
                                <div class="right-aligned-container">
                                    <video controls className="character-learning-video-player">
                                        <source src={`${process.env.PUBLIC_URL}/assets/video/a.MP4`} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
      <Footer />
    </div>
  );
}



export default Writting